import { writable } from 'svelte/store';

export const isAuth = writable(false);
export const User = writable();
export const Registered = writable(false);
export const russianMonths = ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня",
    "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];


export function getCookie(key) {
    let cookies = document.cookie.split('; ');
    let cookieKey = key + "=";
    let cookie = cookies.find((cookie) => cookie.indexOf(cookieKey) === 0)
    if (cookie) {
        return cookie.replace(cookieKey, '');
    }
    else {
        return undefined
    }
}

export function deleteEmptyCookies() {
    const cookies = document.cookie.split(';');
  
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      const [name, value] = cookie.split('=');
      if (value === '') {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`; 
      }
    }
  }
  

export function request(url, method = 'GET', body = null, accept = 'application/json', contentType = 'application/json') {
    const token = getCookie('token');
    const headers = {};
    headers.Authorization = `Bearer ${token ? token : ''}`;
    if (accept) {
        headers.Accept = accept;
    }
    if (contentType) {
        headers["Content-Type"] = contentType;
    }
    const options = {
        method,
        headers
    };
    if (body) {
        options.body = body;
    }

    return fetch(url, options).then((response) => {
        return response.ok ? response.json().then((json) => json.data) : null;
    });
}

export function getFile(url) {
    const token = getCookie('token');
    const headers = {};
    const method = "GET";
    headers.Authorization = `Bearer ${token ? token : ''}`;
    const options = {
        method,
        headers
    };

    return fetch(url, options).then((response) => {
        return response.ok ? response.blob() : null;
    });
}

export function getNews(url) {
    return request(url, "GET").then(
        (response) => {
            if (response) {
                return getNewsData(response);
            }
        }
    );
}

export function getNewsData(response) {
    let myNews = response[0];
    let myMedia = response[1].reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {});;
    for (let i = 0; i < myNews.length; i++) {
        myNews[i][5] = myMedia[myNews[i][5]];
        myNews[i][6] = myNews[i][6].split(", ").map(key => myMedia[key]);
        myNews[i][7] = myNews[i][7].split(", ").map(key => myMedia[key]);
    }
    return myNews;
}

export function checkAuth() {
    const url = '/api/authcheck';
    const token = getCookie('token');
    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token ? token : ''}`
        },
    };

    return fetch(url, options).then((response) => {
        return { auth: response.ok };
    }).catch(() => {
        return { auth: false };
    });
}

export function getUser() {
    const url = "/api/user";
    return request(url);
}

export function getGroups() {
    const url = "/api/groups";
    return request(url);
}